// Unified color system for the entire application
export const colors = {
  // Primary colors
  primary: {
    main: '#262B38', // rgb(38, 43, 56) - Dark blue-gray
    light: '#F1F2F3', // rgb(241, 242, 243) - Light gray
    dark: '#000000', // #000 - Black
  },
  
  // Secondary colors
  secondary: {
    main: '#00FF80', // rgb(0, 255, 128) - Bright green
    light: '#5CFFFF', // rgb(92, 255, 255) - Light cyan
    dark: '#15418E', // #15418e - Dark blue
  },
  
  // Accent colors
  accent: {
    purple: '#5900FF', // rgb(89, 0, 255) - Purple
    cyan: '#5CFFFF', // rgb(92, 255, 255) - Cyan
    red: '#FF3425', // rgb(255, 52, 37) - Red
  },
  
  // Neutral colors
  neutral: {
    white: '#FFFFFF', // rgb(255, 255, 255) - White
    lightGray: '#E0E0E0', // rgb(224, 224, 224) - Light gray
    border: '#CDD1D4', // #CDD1D4 - Border gray
    transparent: 'transparent', // Transparent color
  },
  
  // Text colors
  text: {
    primary: '#FFFFFF', // rgb(255, 255, 255) - White text
    secondary: '#262B38', // rgb(38, 43, 56) - Dark text
    accent: '#00FF80', // rgb(243, 240, 202) - Light yellow text
  },
  
  // Background colors
  background: {
    primary: '#171A23', // rgb(28, 33, 46) - Main background
    secondary: '#F1F2F3', // rgb(241, 242, 243) - Secondary background
    white: '#FFFFFF', // rgb(255, 255, 255) - White background
  },
  
  // Button colors
  button: {
    primary: '#FFFFFF', // #fff - Primary button
    secondary: '#262B38', // rgb(38, 43, 56) - Secondary button
    accent: '#00FF80', // rgb(0, 255, 128) - Accent button
  },
  
  // Shadow colors
  shadow: {
    primary: 'rgba(0, 255, 128, 0%)', // rgb(0 255 128 / 0%)
    hover: 'rgba(0, 255, 128, 20%)', // rgb(0 255 128 / 20%)
    focus: 'rgba(89, 0, 255, 1)', // rgb(89, 0, 255) - Purple shadow
    dark: 'rgba(0, 0, 0, 0.1)', // rgb(0 0 0 / 10%)
  }
} as const;

// Type for color names
export type ColorName = keyof typeof colors;

// Helper function to get nested color values
export const getColor = (path: string): string => {
  const keys = path.split('.');
  let value: any = colors;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      console.warn(`Color path "${path}" not found`);
      return '#000000'; // Fallback color
    }
  }
  
  return value;
};

// Export individual color categories for convenience
export const { primary, secondary, accent, neutral, text, background, button, shadow } = colors; 